export const InstagramFeed = (props) => {
    return (
        <div id='instagramFeed' className='text-center'>
            <div className="elfsight-app-23fe1bfe-f932-476f-9015-8b111507839b"></div>
        </div>
    )
}